import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Loader2, XCircle } from "lucide-react";
import BrandHeader from "../components/BrandHeader";
import { Button } from "../components/ui/button";
import { useSession } from "../context/SessionContext";
import { getProject } from "../lib/api";

export default function ProjectReturn() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { setSession } = useSession();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    getProject(token)
      .then((s) => {
        setSession(s);
        navigate(s.pathway === "diagnose" ? "/diagnose" : "/improve", { replace: true });
      })
      .catch(() => setFailed(true));
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-[100dvh] bg-[#f8faf8]">
      <BrandHeader title="GreenFlow Landscape Vision" subtitle="Your project" />
      <main className="mx-auto max-w-md px-5 py-12 text-center" data-testid="project-return-page">
        {failed ? (
          <>
            <XCircle className="mx-auto text-amber-500" size={44} />
            <h1 data-testid="project-link-invalid" className="mt-4 font-display text-2xl font-bold text-[#092C15]">We couldn't find that project</h1>
            <p className="mt-2 text-sm text-slate-600">Please check the link in your GreenFlow email, or contact askDr.Verdant@greenflowlandcare.com.</p>
            <Button data-testid="project-home-button" onClick={() => navigate("/")} className="mt-6 rounded-xl h-12 px-6 bg-emerald-600 hover:bg-emerald-700">Go to Home</Button>
          </>
        ) : (
          <>
            <Loader2 className="mx-auto animate-spin text-emerald-600" size={40} />
            <h1 className="mt-4 font-display text-2xl font-bold text-[#092C15]">Opening your project…</h1>
          </>
        )}
      </main>
    </div>
  );
}
